// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RestoreSessionStatus {
    Running = 0,
    Stopped = 1
}
